import React, { Component } from 'react';
// import _ from 'lodash';
import {
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip,
  FormGroup
} from 'reactstrap';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import Select from 'react-select';
import paginationFactory from 'react-bootstrap-table2-paginator';
import draftToHtml from 'draftjs-to-html';
import ReactHtmlParser from 'react-html-parser';
import Mezo from './Mezo';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ToolbarBase from '../../../components/Wysiwyg/toolbar/ToolbarBase';
import Wysiwyg from '../../../components/Wysiwyg/Wysiwyg';
import Lib from '../../../commons/lib';
import ProgressButton from '../../../commons/ProgressButton';

class TeremContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentRow: {},
      modalNezet: false,
      modalTerem: false,
      modalTeremTorles: false,
      modalTeremModosit: false,
      teremModositObj: {},
      loading: false,
      helyszin: null,
      allapot: null,
      terem: {},
      mezoJson: {},
      nestedModal: false,
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      statusz: [],
      statuszOptions: [],
      helyszinOptions: [],
      raktarOptions: [],
      filterOptions: {},
      leiras: null,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.updateTable();
    }
  }

  listHelyszinek = () => {
    Services.listHelyszin((err, res) => {
      if (!err) {
        const options = res[0].list;
        this.setState({
          helyszinOptions: options.map(e => <option key={e.id} value={e.id}>{e.nev}</option>),
          helyszin: options.length === 1 ? options[0] : null,
          helyszinid: options.length === 1 ? options[0].id : null,
        });
      }
    });
  }

  listAllapotok = () => {
    Services.listTeremAllapot((err, res) => {
      if (!err) {
        this.setState({
          allapotok: res[0]
        });
      }
    });
  }

  listRaktarak = () => {
    Services.listRaktar((err, res) => {
      if (!err) {
        this.setState({
          raktarOptions: res[0].list.map(e => <option key={e.id} value={e.id}>{e.nev}</option>),
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  onChange = (value) => {
    this.setState({ leiras: value });
  };

  handleViewClick = (id) => {
    Services.viewTerem(id, (err, res) => {
      if (!err) {
        this.setState({ mezoJson: res[0].metaadatok, terem: res[0] });
        this._currentViewId = id;
        this.toggleNezet();
      } 
    });
  }


  hasRoleKarb = () => {
    if (this.props.globals.hasRole(['HELYSZIN_TEREM'], true)) return true;
    return false;
  }

  handleEditClick = (id) => {
    this.listRaktarak();
    this.listAllapotok();
    this.getTerem(id);
  }

  handleTeremDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTeremTorles();
  }

  iconFormatter = (cell) => {
    return (
      <div>
        {
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} />
            {this.hasRoleKarb()
              ? (
                <React.Fragment>
                  <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} />
                  <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleTeremDeleteClick(cell)} />
                </React.Fragment>
              )
              : <div />}
          </React.Fragment>
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {this.hasRoleKarb()
          ? (
            <div>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
            </div>
          ) : <div />}
      </div>
    );
  }

  statuszFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  updateTable = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listTerem((err, res) => {
        if (!err) {
          let filters = {};
          let options = res[0].statusz.map((e) => {
            filters[e.name] = e.caption;

            return <option key={e.name} value={e.name}>{e.caption}</option>;
          });

          this.setState({
            teremJson: res[0].list,
            tableStatus: res[0].list.length > 0 ? 'TABL' : 'DATA',
            statusz: res[0].statusz,
            statuszOptions: options,
            filterOptions: filters
           });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  toggleNested = () => {
    this.setState({
      nestedModal: !this.state.nestedModal
    });
  }

  toggleNezet = () => {
    this.setState({
      modalNezet: !this.state.modalNezet
    });
  }

  toggleTerem = () => {
    if (!this.state.modalTerem) {
      this.listHelyszinek();
      this.listRaktarak();
      this.listAllapotok();
    }
    this.setState((prevState) => { return ({ modalTerem: !prevState.modalTerem, helyszin: null, raktar: null, allapot: 'AKTIV', mezoJson: {}, leiras: '' }); });
  }

  toggleTeremModosit = () => {
    if (this.state.modalTeremModosit) {
      this.setState({ mezoJson: {} });
    }
    this.setState((prevState) => { return ({ modalTeremModosit: !prevState.modalTeremModosit }); });
  }

  toggleTeremTorles = () => {
    this.setState((prevState) => { return ({ modalTeremTorles: !prevState.modalTeremTorles }); });
  }

  addMezo = (event, mezoObj) => {
    let ujObj = {};
    ujObj[mezoObj.mezonev] = mezoObj.tartalom;
    this.setState({ mezoJson: Object.assign(this.state.mezoJson, ujObj) });
    this.toggleNested();
  }

  updateMetaadat = (event, mezonev) => {
    this.state.mezoJson[mezonev] = event.target.value;
  }

  deleteMetaadat = (mezonev) => {
    delete this.state.mezoJson[mezonev];
    this.setState({ mezoJson: this.state.mezoJson });
  }

  getTerem = (id) => {
    this._currentId = id;
    Services.getTerem(id, (err, res) => {
      if (!err) {
        this.setState(() => {
          return ({
            azonosito: res[0].azonosito,
            nev: res[0].nev,
            helyszin: res[0].helyszin,
            raktarId: res[0].raktarid,
            allapot: res[0].allapot ? res[0].allapot.name : null,
            leiras: res[0].leiras,
            mezoJson: res[0].metaadatok,
            currentId: id
          });
        }, () => {
          this.toggleTeremModosit();
        });
      }
    });
  }

  addTerem = (event, teremObj) => {
    if (this.state.helyszinid == null) {
      this.props.globals.addError('Helyszín választása kötelező!')
    } else {
      teremObj.metaadatok = this.state.mezoJson;
      teremObj.leiras = this.state.leiras;
      this.setState({ addButtonLoading: true });
      Services.addTerem(teremObj, (err) => {
        if (!err) {
          this.setState({ mezoJson: {} });
          this.toggleTerem();
          this.updateTable();
          this.props.globals.addSuccess('Terem hozzáadva!');
        }
        this.setState({ addButtonLoading: false });
      });
    }
  }

  editTerem = (event, teremObj) => {
    let teremModositObj = {};
    teremModositObj.id = this._currentId;
    teremModositObj.nev = this.state.nev;
    teremModositObj.raktarId = this.state.raktarId
    teremModositObj.allapot = this.state.allapot;
    teremModositObj.leiras = this.state.leiras;
    teremModositObj.metaadatok = this.state.mezoJson;
    this.setState({ modifyButtonLoading: true });
    Services.modifyTerem(teremModositObj, (err) => {
      if (!err) {
        this.setState({ mezoJson: {} });
        this.toggleTeremModosit();
        this.updateTable();
        this.props.globals.addSuccess('Terem módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteTerem = () => {
    this.toggleTeremTorles();
    this.setState({ deleteButtonLoading: true });
    Services.deleteTerem(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.setState({ currentRow: [] });
        this.props.globals.addSuccess('Terem törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  renderMezok = () => {
    let mezok = [];
    let idx = 0;
    for (let mezonev in this.state.mezoJson) {
      mezok.push(<Mezo mezonev={mezonev} tartalom={this.state.mezoJson[mezonev]} updateMeta={e => this.updateMetaadat(e, mezonev)} key={idx} delete={this.deleteMetaadat} />);
      idx++;
    }
    return mezok;
  }

  renderMezokLeiras = () => {
    let mezok = [];
    for (let mezonev in this.state.mezoJson) {
      mezok.push(<div key={mezonev}><b>{mezonev}: </b>{this.state.mezoJson[mezonev]}<br /></div>);
    }
    return mezok;
  }

  renderAdatok = (id) => {
   return (
      <div>
        <b>Helyszín név: </b>{this.state.terem.helyszin}<br />
        <b>Terem név: </b>{this.state.terem.nev}<br />
        <b>Terem azonosító: </b>{this.state.terem.azonosito}<br />
        <b>Raktár: </b>{this.state.terem.raktar}<br />
        <b>Állapot: </b>{this.state.terem.allapot}<br />
        <b>Leírás: </b>{ReactHtmlParser(this.state.terem.leiras)}<br />
        <br />
        <h5>Kiegészítő adatok:</h5>
        <div>{this.renderMezokLeiras()}</div>
      </div>
    );
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'helyszin',
        text: 'Helyszín név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Terem név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Terem azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...'
        }),
        sort: true
      },
      {
        dataField: 'allapot.name',
        align: 'center',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        sort: true,
        formatter: this.statuszFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.teremJson}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb()
              ? (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.toggleTerem}>Új terem hozzáadása</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.state.tableStatus === 'TABL' ? this.renderTable() : this.state.tableStatus === 'NETW' ? <NetworkEmptyState hasImage submitClick={this.updateTable} /> : this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage submitClick={this.updateTable} /> : <Loader />}
        {/* <Modal isOpen={this.state.modalTerem} toggle={this.toggleTerem} className={this.props.className} backdrop="static"> */}
          <RFForm
            onSubmit={this.addTerem}
            modalInsert
            title={'Terem felvétel'}
            tagProps={{ isOpen: this.state.modalTerem, toggle: this.toggleTerem, className: this.props.className, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <ProgressButton color="primary" loading={this.state.addButtonLoading}>Mentés</ProgressButton>
                {' '}
                <Button type="button" color="secondary" onClick={this.toggleTerem}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {/* <ModalHeader>Terem felvétel</ModalHeader>
            <ModalBody> */}
              <div>
                <RFField
                  label={'Terem azonosító: *'}
                  name="azonosito"
                  id="azonosito"
                  maxLength={10}
                  required
                  onChange={this.handleInputChange}
                />
       
              </div>
              <div>
                <RFField
                  label={'Terem név: *'}
                  name="nev"
                  id="nev"
                  maxLength={50}
                  required
                  onChange={this.handleInputChange}
                />
       
              </div>
              <div>
                <RFField
                  type="select"
                  name="helyszinid"
                  label="Helyszín: *"
                  required
                  value={this.state.helyszinid}
                  defaultSelect={<option value="">Válassz helyszínt...</option>}
                  selectOptions={this.state.helyszinOptions}
                  onChange={this.handleInputChange}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <RFField
                  type="select"
                  name="raktarId"
                  label="Raktár:"
                  defaultSelect={<option value="">Válassz raktárat...</option>}
                  selectOptions={this.state.raktarOptions}
                  onChange={this.handleInputChange}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <RFField
                  type="select"
                  name="allapot"
                  label="Állapot: *"
                  required
                  value={this.state.allapot}
                  selectOptions={this.state.statuszOptions}
                  onChange={this.handleInputChange}
                />
              </div>
              {this.state.leiras}
              <Label for="leiras">Leírás:</Label>
              <Wysiwyg
                value={this.state.leiras}
                onChange={this.onChange}
                toolbar={() => <ToolbarBase />}
              />
              {this.renderMezok()}
              <Button type="button" id="UjMezo" className="btn-cursor-pointer mt-1" color="success" onClick={this.toggleNested}>Új mező</Button>
              <UncontrolledTooltip trigger='hover focus-visible' placement="right" target="UjMezo">
                Új mező, jellemző hozzáadása a teremhez.
              </UncontrolledTooltip>
            {/* </ModalBody>
            <ModalFooter>
              <Button color="primary">Mentés</Button>
              {' '}
              <Button type="button" color="secondary" onClick={this.toggleTerem}>Mégsem</Button>
            </ModalFooter> */}
          </RFForm>
        {/* </Modal> */}
        <Modal isOpen={this.state.modalTeremTorles} toggle={this.toggleTeremTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a termet?</ModalBody>
          <ModalFooter>
            <ProgressButton color="primary" onClick={this.deleteTerem} loading={this.state.deleteButtonLoading}>OK</ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleTeremTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        {/* <Modal isOpen={this.state.modalTeremModosit} toggle={this.toggleTeremModosit} className={this.props.className} backdrop="static"> */}
          <RFForm
            onSubmit={this.editTerem}
            modalInsert
            title={'Terem módosítás'}
            tagProps={{ isOpen: this.state.modalTeremModosit, toggle: this.toggleTeremModosit, className: this.props.className, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <ProgressButton color="primary" loading={this.state.modifyButtonLoading}>Mentés</ProgressButton>
                  {' '}
                <Button type="button" color="secondary" onClick={this.toggleTeremModosit}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {/* <ModalHeader>Terem módosítás</ModalHeader>
            <ModalBody> */}
              <div>
                {/* <Label for="azonosito">Terem azonosító: *</Label> */}
                <RFField
                  label={'Terem azonosító: *'}
                  name="azonosito"
                  id="azonosito"
                  value={this.state.azonosito}
                  maxLength={10}
                  disabled
                />
              </div>
              <div>
                {/* <Label for="nev">Terem név: *</Label> */}
                <RFField
                  label={'Terem név: *'}
                  name="nev"
                  id="nev"
                  value={this.state.nev}
                  maxLength={50}
                  required
                  onChange={this.handleInputChange}
                />
              </div>
              <div>
                <RFField
                  label={'Helyszín: *'}
                  name="helyszin"
                  id="helyszinid"
                  value={this.state.helyszin}
                  disabled
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <RFField
                  type="select"
                  name="raktarId"
                  label="Raktár:"
                  defaultSelect={<option value="">Válassz raktárat...</option>}
                  selectOptions={this.state.raktarOptions}
                  onChange={this.handleInputChange}
                  value={this.state.raktarId}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <RFField
                  type="select"
                  name="allapot"
                  label="Állapot: *"
                  required
                  value={this.state.allapot}
                  selectOptions={this.state.statuszOptions}
                  onChange={this.handleInputChange}
                />
              </div>
              <Label for="leiras">Leírás:</Label>
              <Wysiwyg
                value={this.state.leiras}
                onChange={this.onChange}
                toolbar={() => <ToolbarBase />}
              />
              {this.renderMezok()}
              <Button type="button" id="UjMezo" className="btn-cursor-pointer mt-1" color="success" onClick={this.toggleNested}>Új mező</Button>
              <UncontrolledTooltip trigger='hover focus-visible' placement="right" target="UjMezo">
                Új mező, jellemző hozzáadása a teremhez.
              </UncontrolledTooltip>
            {/* </ModalBody>
            <ModalFooter>
              <Button color="primary">Mentés</Button>
              {' '}
              <Button type="button" color="secondary" onClick={this.toggleTeremModosit}>Mégsem</Button>
            </ModalFooter> */}
          </RFForm>
        {/* </Modal> */}
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader>Terem információ</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={this.toggleNezet}>Vissza</Button>
          </ModalFooter>
        </Modal>
        {/* <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} backdrop="static"> */}
          <RFForm
            onSubmit={this.addMezo}
            modalInsert
            title={'Új terem jellemző felvétel'}
            tagProps={{ isOpen: this.state.nestedModal, toggle: this.toggleNested, backdrop: 'static' }}
            footer={
              <React.Fragment>
                <Button color="primary">Hozzáadás</Button>
                  {' '}
                <Button type="button" color="secondary" onClick={this.toggleNested}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {/* <ModalHeader>Új terem jellemző felvétel</ModalHeader>
            <ModalBody> */}
              <div>
                {/* <Label for="mezonev">Mező neve: *</Label> */}
                <RFField label={'Mező neve: *'} name="mezonev" id="mezonev" regex={[/[^\d]/g, "A mező nem tartalmazhat csak számot!"]} required />
       
              </div>
              <div>
                {/* <Label for="tartalom">Mező tartalma: *</Label> */}
                <RFField label={'Mező tartalma: *'} name="tartalom" id="tartalom" required />
       
              </div>
            {/* </ModalBody>
            <ModalFooter>
              <Button color="primary">Hozzáadás</Button>
              {' '}
              <Button type="button" color="secondary" onClick={this.toggleNested}>Mégsem</Button>
            </ModalFooter> */}
          </RFForm>
        {/* </Modal> */}
      </div>
    );
  }
}

export default TeremContent;
